
  import { Person } from '@/entities/persons/Person'
  import { Component } from 'vue-property-decorator'
  import Cell from './cell'

@Component
  export default class NameRutCell extends Cell {
    declare item: Person
    person: Person = null

    async mounted () {
      this.person = (await this.fetchData({
        query: { name: 'find', model: 'Person' },
        filter: { id: { _eq: this.item.id } },
        force: true,
      }))[0]
    }

    get name () {
      const { person } = this

      return person?.shortName || ''
    }

    get uid () {
      const { person } = this

      return person?.uid || ''
    }
  }
